import { render, staticRenderFns } from "./BuildDiploma.vue?vue&type=template&id=462e7ebe&scoped=true"
import script from "./BuildDiploma.vue?vue&type=script&lang=js"
export * from "./BuildDiploma.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462e7ebe",
  null
  
)

export default component.exports